export const sortArrayByQuery = (
  array: { value: string; label: string; group?: string }[],
  query: string
) => {
  return array.sort((a, b) => {
    const labelA = a.label.toLowerCase();
    const labelB = b.label.toLowerCase();

    const target = query.toLowerCase();

    if (labelA.startsWith(target) && !labelB.startsWith(target)) {
      return -1;
    } else if (!labelA.startsWith(target) && labelB.startsWith(target)) {
      return 1;
    } else {
      return labelA.localeCompare(labelB);
    }
  });
};
